import React, { PropsWithChildren } from "react";
import { useDropzone } from "react-dropzone";

const FileDropzone = (
  p: PropsWithChildren<{
    isDisabled?: boolean;
    onAddFiles: (files: File[]) => void;
  }>,
) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: p.onAddFiles,
    noClick: true,
    noKeyboard: true,
    noDragEventsBubbling: true,
    disabled: p.isDisabled,
  });

  return (
    <div
      className="relative h-full w-full cursor-default overflow-hidden"
      {...getRootProps()}
    >
      <input aria-hidden="true" {...getInputProps()} />
      {isDragActive && (
        <div
          className="absolute inset-0 z-50 m-2 flex items-center justify-center 
          rounded-md border-4 border-dashed border-gray-800 bg-white bg-opacity-90"
        >
          <h3 className="text-gray-900">Drop files to upload</h3>
        </div>
      )}
      {p.children}
    </div>
  );
};

export default FileDropzone;
